<script>
import { genderFilter, taiwanCitys, sexFilter, districtsFilter, findDistrictZip, taxTypeMap, carrierTypeMap } from '@utils/filter-value-to-text'
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import lazyLoadComponent from '@router/lazyload-component'
import _debounce from 'lodash/debounce'

const defaultAddress = () => {
  return {
    address: '',
    city: '',
    district: '',
    email: '',
    name: '',
    phone: '',
    postcode: '',
  }
}

const extraInfoPhone = {
  // type:'phone',
  phoneCode: '+886',
  phoneNumber: '',
}

const extraInfoEmergency = {
  // type:'emergency',
  phoneCode: '+886',
  phoneNumber: '',
  fullName: '',
  gender: 'male',
}

const initPhoneNumber = {
  phoneNumber: '',
  phoneCode: '+886',
}

export default {
  components: {
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    BaseButtonDialog: () => lazyLoadComponent(import('@components/BaseButtonDialog')),
  },
  filters: { genderFilter, sexFilter },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      taxTypeMap,
      carrierTypeMap,
      taiwanCitys,
      // submitData: cloneDeep(Object.assign({},
      // {
      //   extraInfos:{
      //     extraInfoPhone:[extraInfoPhone],
      //     extraInfoEmergency:[extraInfoEmergency]
      //   }
      // },
      // this.submitData, { merchantNote: this.submitData.merchantNote && this.submitData.merchantNote.replace(/<br\s\/>/g, '') },
      // // {extraInfos:this.submitData.extraInfos[0]?cloneDeep(this.submitData.extraInfos):[extraInfoPhone,extraInfoEmergency]}
      // )),
      // editedNote: null,
      // editEnabled: false,
      editTagEnabled: false,
      removeTags: new Set(),
      tagList: [],
      tryingUpdateTag: false,
      addressMode: 'billing',
      tryingSave: false,
      visibleDialog: false,
      editDetailEnabled: false,
      editInvoiceEnabled: false,
      saveLoading: {
        info: false,
        tag: false,
        tax: false,
        note: false,
        memberlevel: false,
      },
      dialogMemberPhoneApplyVisible: false,
      innerDialogNextCheckApplytVisible: false,
      defaultData: cloneDeep(this.value),
      submitPhone: {
        phoneNumber: '',
        phoneCode: '+886',
      },
      phoneMmeber: {
        name: '',
        gender: '',
        phoneNumber: '',
        phoneCode: '',
      },
      isHasPhoneNumber: false,
      isCheckRegExp: false,
      isEditingNationalId: false,
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    rules() {
      const isTaiwan = this.submitPhone.phoneCode === '+886'
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
      }
    },
    addIds() {
      return this.allIds.filter((id) => !this.defaultTagIds.includes(id) && this.submitDataTagIds.includes(id))
    },
    deleteIds() {
      return this.allIds.filter((id) => this.defaultTagIds.includes(id) && !this.submitDataTagIds.includes(id))
    },
    defaultTagIds() {
      return this.defaultData.tags.map((tag) => tag.id)
    },
    submitDataTagIds() {
      return this.submitData.tags.map((tag) => tag.id)
    },
    allIds() {
      return [...new Set([...this.defaultTagIds, ...this.submitDataTagIds])]
    },
    districts() {
      let districts = []
      if (this.addressMode === 'shipping') {
        districts = this.submitData[`${this.addressMode}Info`][0].city
      }
      if (this.addressMode === 'billing') {
        districts = this.submitData[`${this.addressMode}Info`].city
      }
      return districtsFilter(districts)
    },
    searchRules() {
      return {
        email: [{ required: false, message: '請輸入 Email' }, { type: 'email', message: '請輸入正確的 Email 格式' }],
        fullName: [{ required: true, message: '請輸入使用人姓名' }],
      }
    },
    addressRules() {
      return {
        'shippingInfo.0.phone': [
          // { required: true, message: '請輸入電話',trigger: 'blur' },
          { pattern: /[\s\#0-9_\-\+\/\(\)\.]/, message: '請輸入正確的 電話 格式', trigger: 'blur' },
        ],
        'billingInfo.phone': [
          // { required: true, message: '請輸入電話',trigger: 'blur' },
          { pattern: /[\s\#0-9_\-\+\/\(\)\.]/, message: '請輸入正確的 電話 格式', trigger: 'blur' },
        ],
      }
    },
    phoneRules() {
      const isTaiwan = this.submitPhone.phoneCode === '+886'

      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
          // {
          //     validator: this.onInputPhoneNumber,
          //     trigger: 'input'
          // }
        ],
      }
    },
    hasHomeService() {
      return this.$hasHomeService()
    },
    isJtails() {
      return this.$store.state.merchant.cached.alias === 'j-tails'
    },
    maskedNationalId() {
      if (this.defaultData.extraInfos?.nationalId) {
        const id = this.defaultData.extraInfos.nationalId

        const firstChar = id.charAt(0).toUpperCase()
        const maskedMiddle = '******'
        const lastThree = id.slice(-3)
        return firstChar + maskedMiddle + lastThree
      }
      return ''
    },
  },
  watch: {
    hasHomeService(value) {
      this.getDefaultAddress()
    },
    value(nvl) {
      this.$nextTick(() => {
        this.defaultData = cloneDeep(this.value)
      })
    },
    editDetailEnabled(nvl, ovl) {
      if (!nvl && ovl) {
        this.setDefaultExtraInfo()
      }
    },
  },
  created() {
    this.tryToFetchList()
    this.setDefaultExtraInfo()
    this.getDefaultAddress()
  },
  mounted() {},
  methods: {
    setDefaultExtraInfo() {
      try {
        const setArr = ['submitData', 'defaultData']
        setArr.forEach((item) => {
          if (!this[item].extraInfos) {
            this[item] = {
              ...this[item],
              extraInfos: {
                extraInfoPhone: [extraInfoPhone],
                extraInfoEmergency: [extraInfoEmergency],
                extraInfoAddressNotJtails: '',
                birthday: '',
                nationalId: '',
              },
            }
          }
          if (!this[item].extraInfos.extraInfoAddressNotJtails) {
            this.$set(this[item]['extraInfos'], 'extraInfoAddressNotJtails', '')
          }
          if (!this[item].extraInfos.extraInfoPhone) {
            this.$set(this[item]['extraInfos'], 'extraInfoPhone', [extraInfoPhone])
          }
          if (!this[item].extraInfos.extraInfoEmergency) {
            this.$set(this[item]['extraInfos'], 'extraInfoEmergency', [extraInfoEmergency])
          }
          if (!this[item].extraInfos.birthday) {
            this.$set(this[item]['extraInfos'], 'birthday', '')
          }
          if (!this[item].extraInfos.nationalId) {
            this.$set(this[item]['extraInfos'], 'nationalId', '')
          }
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    getDefaultAddress() {
      if (this.$hasHomeService()) {
        if (!this.submitData.billingInfo) {
          this.submitData.billingInfo = defaultAddress()
        }
        if (!this.submitData.shippingInfo) {
          this.submitData.shippingInfo = [defaultAddress()]
        }
      }
    },
    enableEditTag() {
      this.editTagEnabled = true
    },
    cancelTagEdit() {
      this.submitData.tags = [...this.submitData.tags]
      this.editTagEnabled = false
    },
    enableEditDetail() {
      const data = {
        isEditEnabled: true,
        type: 'info',
      }
      this.editDetailEnabled = true
      this.$emit('isEditDeatilEnabled', data)
    },
    async updateTag() {
      this.tryingUpdateTag = true
      await this.$store.dispatch('member/applyTags', {
        addIds: this.addIds,
        deleteIds: this.deleteIds,
        memberIds: [this.submitData.id],
      })
      this.$emit('update')
      this.$nextTick(() => {
        this.cancelTagEdit()
        this.tryingUpdateTag = false
      })
    },
    async tryToFetchList(search) {
      this.tagList = await this.$store.dispatch('member/fetchTags', {
        search,
      })
    },
    /*     async tryToFetchMember() {
          const memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId:this.$route.params.memberId })
          this.$emit('update:submitData', memberInfo)
        }, */
    enableEditAddress(mode) {
      this.addressMode = mode
      this.visibleDialog = true
    },
    onSelectCity() {
      const city = this.addressMode === 'billing' ? this.submitData.billingInfo.city : this.submitData[`${this.addressMode}Info`][0].city
      const currentCity = this.taiwanCitys.find((item) => {
        return item.name === city
      })
      if (this.addressMode === 'billing') {
        this.submitData[`${this.addressMode}Info`] = {
          ...this.submitData[`${this.addressMode}Info`],
          district: currentCity?.districts[0].name || '',
          postcode: currentCity?.districts[0].zip || '',
        }
      }
      if (this.addressMode === 'shipping') {
        this.submitData[`${this.addressMode}Info`][0].district = currentCity?.districts[0].name || ''
        this.submitData[`${this.addressMode}Info`][0].postcode = currentCity?.districts[0].zip || ''
      }
    },
    onSelectDistrict() {
      if (this.addressMode === 'shipping') {
        const { city, district } = this.submitData[`${this.addressMode}Info`][0]
        this.submitData[`${this.addressMode}Info`][0].postcode = findDistrictZip(city, district)
      }
      if (this.addressMode === 'billing') {
        const { city, district } = this.submitData[`${this.addressMode}Info`]
        this.submitData[`${this.addressMode}Info`].postcode = findDistrictZip(city, district)
      }
    },
    async onSaveAddress() {
      try {
        // await this.$refs.addressForm.validate()
        this.tryingSave = true
        this.$emit('save')
        this.visibleDialog = false
      } catch {
      } finally {
        this.tryingSave = false
      }
    },
    handleClose() {
      // this.submitData = cloneDeep(this.defaultData)
      this.getDefaultAddress()
      this.visibleDialog = false
    },
    onInputPhoneNumber(value) {
      this.isCheckRegExp = false
      const isTaiwan = this.submitPhone.phoneCode === '+886'
      if (isTaiwan) {
        const phoneRegExp = new RegExp(/^09\d{8}$/)
        if (phoneRegExp.test(this.submitPhone.phoneNumber)) {
          this.isCheckRegExp = true
        } else {
          this.isCheckRegExp = false
        }
      } else {
        this.isCheckRegExp = true
      }
    },
    async tryToSendPhoneApply() {
      const submitData = {
        oldPhone: `${this.submitData.phoneCode}-${this.submitData.phoneNumber}`,
        newPhone: `${this.submitPhone.phoneCode}-${this.submitPhone.phoneNumber}`,
      }
      await this.$store
        .dispatch('member/changePhone', submitData)
        .then((res) => {
          if (res.code === 200) {
            this.$alert(`申請送出`, '申請送出', {
              confirmButtonText: '確認',
              center: true,
              callback: () => {
                this.dialogMemberPhoneApplyVisible = false
              },
            })
            this.isHasPhoneNumber = false
          }
        })
        .catch((error) => {
          if (error.message === 'new phone already exist') {
            this.$message({ message: '此號碼已註冊', type: 'error' })
            const { gender, name, newPhone } = error.data
            this.phoneMmeber = {
              gender,
              name,
              phoneCode: newPhone.split('-')[0],
              phoneNumber: newPhone.split('-')[1],
            }
            this.isHasPhoneNumber = true
          }
        })
        .finally(() => {})
    },
    handleMemberPhoneApplyClose() {
      this.isCheckRegExp = false
      this.isHasPhoneNumber = false
      this.submitPhone = { ...initPhoneNumber }
    },
    // submitMemberPhoneApply() {
    //   this.innerDialogNextCheckApplytVisible = false;
    //   this.dialogMemberPhoneApplyVisible = false
    //   this.handleMemberPhoneApplyClose()
    // }
    reInputNationalId() {
      // 切換到重新輸入模式，並清空舊資料
      this.isEditingNationalId = true
      this.submitData.extraInfos.nationalId = ''
    },
    toUpperCase(val) {
      this.submitData.extraInfos.nationalId = val.toUpperCase()
    },
  },
}
</script>

<template>
  <div>
    <BasePageHeader title="基本資料">
      <template v-slot:right>
        <el-button v-if="!editDetailEnabled" class="is-round isStyleBase" @click="dialogMemberPhoneApplyVisible = true">
          <BaseIcon name="sync" />
          客戶手機變更申請
        </el-button>
        <el-button v-if="!editDetailEnabled" type="primary" class="is-round isStyleBase" @click="enableEditDetail">
          編輯基本資料
        </el-button>
      </template>
    </BasePageHeader>
    <div class="isStylePageContent">
      <h4 class="form-block-title">客戶資料 </h4>
      <ul :class="$style.detail">
        <!-- 編輯mode -->
        <template v-if="editDetailEnabled">
          <el-form ref="form" :model="submitData" :class="$style['detail-form']" label-position="top" :rules="searchRules" label-width="130px">
            <el-row>
              <el-col :span="18">
                <el-form-item prop="fullName" label="姓名" class="el-form-item--normal-margin">
                  <el-input v-model="submitData.fullName" placeholder="姓名" class="bg-white is-border">
                    <!-- <el-select slot="append" v-model="submitData.gender" placeholder="性別">
                    <el-option value="female" label="小姐"></el-option>
                    <el-option value="male" label="先生"></el-option>
                  </el-select> -->
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item class="el-form-item--normal-margin gender-box" label-width="0" style="margin-left:20px;margin-bottom:0;height:auto">
                  <el-radio-group v-model="submitData.gender" class="no-bg-radio-group">
                    <el-radio label="male">先生</el-radio>
                    <el-radio label="female">小姐</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="生日" class="el-form-item--normal-margin">
              <el-date-picker v-model="submitData.extraInfos.birthday" type="date" value-format="yyyy-MM-dd" class="bg-white is-border"></el-date-picker>
            </el-form-item>

            <!-- 身份證號碼第一次輸入明碼 如果後端有資料就顯示暗碼 -->
            <el-col :span="24">
              <el-form-item label="身份證字號" class="el-form-item--normal-margin">
                <template v-if="!isEditingNationalId">
                  <!-- 顯示遮蔽字串，禁止編輯 -->
                  <el-input :value="maskedNationalId" disabled> </el-input>
                  <el-button type="text" @click="reInputNationalId">重新輸入</el-button>
                </template>

                <template v-else>
                  <!-- 重新輸入時，欄位清空 -->
                  <el-input v-model.trim="submitData.extraInfos.nationalId" @input="toUpperCase" placeholder="請輸入身份證字號" maxlength="10" show-word-limit />
                </template>
              </el-form-item>
            </el-col>

            <li style="margin-bottom: 22px">聯絡電話：{{ `${submitData.phoneCode} ${submitData.phoneNumber}` }}</li>

            <el-form-item label="備用電話" class="el-form-item--normal-margin">
              <el-input v-model.trim="submitData.extraInfos.extraInfoPhone[0].phoneNumber" placeholder="請輸入備用電話" class="bg-white is-border">
                <CountryCodePicker slot="prepend" v-model="submitData.extraInfos.extraInfoPhone[0].phoneCode" />
              </el-input>
            </el-form-item>

            <el-row>
              <el-col :span="18">
                <el-form-item label="緊急聯絡人姓名" class="el-form-item--normal-margin">
                  <el-input v-model="submitData.extraInfos.extraInfoEmergency[0].fullName" placeholder="請輸入姓名" class="bg-white is-border"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item class="el-form-item--normal-margin gender-box" label-width="0" style="margin-left:20px;margin-bottom:0;height:auto">
                  <el-radio-group v-model="submitData.extraInfos.extraInfoEmergency[0].gender" class="no-bg-radio-group">
                    <el-radio label="male">先生</el-radio>
                    <el-radio label="female">小姐</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="緊急聯絡人電話" class="el-form-item--normal-margin">
              <el-input v-model.trim="submitData.extraInfos.extraInfoEmergency[0].phoneNumber" placeholder="請輸入緊急聯絡人電話" class="bg-white is-border">
                <CountryCodePicker slot="prepend" v-model="submitData.extraInfos.extraInfoEmergency[0].phoneCode" />
              </el-input>
            </el-form-item>

            <el-form-item prop="email" label="電子信箱" class="el-form-item--normal-margin" style="margin-left: -4px">
              <el-input v-model="submitData.email" placeholder="Email" class="bg-white is-border"> </el-input>
            </el-form-item>

            <el-form-item label="LINE ID" class="el-form-item--normal-margin" style="margin-left: -4px">
              <el-input v-model="submitData.lineId" placeholder="LINE ID" class="bg-white is-border"> </el-input>
            </el-form-item>
            <!-- <el-form-item v-if="!$hasHomeService()" label="地址" class="el-form-item--normal-margin"
              style="margin-left: -4px">
              <el-input v-model="submitData.extraInfos.extraInfoAddressNotJtails" placeholder="地址"
                class="bg-white is-border">
              </el-input>
            </el-form-item> -->
          </el-form>
        </template>
        <!-- 顯示mode -->
        <template v-else>
          <li>姓名：{{ defaultData.fullName }} {{ defaultData.gender | genderFilter }}</li>
          <li v-if="$merchantI18n() === 'beauty'">性別：{{ defaultData.gender | sexFilter }}</li>
          <li>生日：{{ defaultData.extraInfos.birthday }}</li>
          <li>身份證字號：{{ maskedNationalId }}</li>
          <li>聯絡電話：{{ `${defaultData.phoneCode} ${defaultData.phoneNumber}` }}</li>
          <li v-if="defaultData.extraInfos && defaultData.extraInfos.extraInfoPhone[0].phoneNumber">
            備用電話：
            {{
              `${defaultData.extraInfos.extraInfoPhone[0].phoneCode}
                        ${defaultData.extraInfos.extraInfoPhone[0].phoneNumber}`
            }}
          </li>
          <li v-if="defaultData.extraInfos && defaultData.extraInfos.extraInfoEmergency[0].fullName">
            緊急聯絡人姓名：
            {{ defaultData.extraInfos.extraInfoEmergency[0].fullName }} {{ defaultData.extraInfos.extraInfoEmergency[0].gender | genderFilter }}
          </li>
          <li v-if="defaultData.extraInfos && defaultData.extraInfos.extraInfoEmergency[0].phoneNumber">
            緊急聯絡人電話：
            {{
              `${defaultData.extraInfos.extraInfoEmergency[0].phoneCode}
                        ${defaultData.extraInfos.extraInfoEmergency[0].phoneNumber}`
            }}
          </li>
          <li>電子信箱：{{ defaultData.email }}</li>
          <li>LINE ID：{{ defaultData.lineId }}</li>
          <li v-if="isJtails">
            帳單地址：
            <template v-if="defaultData.billingInfo">
              {{ defaultData.billingInfo.city }} {{ defaultData.billingInfo.district }} {{ defaultData.billingInfo.address }}
            </template>
            <el-button type="primary" class="is-round" size="mini" plain @click="enableEditAddress('billing')">
              <BaseIcon name="edit" />
              <span>編輯</span>
            </el-button>
          </li>
          <li>
            地址：
            <template v-if="defaultData.shippingInfo">
              {{ defaultData.shippingInfo[0].city }} {{ defaultData.shippingInfo[0].district }} {{ defaultData.shippingInfo[0].address }}
            </template>
            <el-button type="primary" class="is-round" size="mini" plain @click="enableEditAddress('shipping')">
              <BaseIcon name="edit" />
              <span>編輯</span>
            </el-button>
          </li>
        </template>
        <!-- <template v-if="$hasHomeService()">
          <li>
            帳單地址：
            <template v-if="defaultData.billingInfo"> {{ defaultData.billingInfo.city }} {{
              defaultData.billingInfo.district }} {{ defaultData.billingInfo.address }} </template>
            <el-button type="primary" class="is-round" size="mini" plain @click="enableEditAddress('billing')">
              <BaseIcon name="edit" />
              <span>編輯</span>
            </el-button>
          </li>
          <li>
            地址：
            <template v-if="defaultData.shippingInfo"> {{ defaultData.shippingInfo[0].city }} {{
              defaultData.shippingInfo[0].district }} {{ defaultData.shippingInfo[0].address }} </template>
            <el-button type="primary" class="is-round" size="mini" plain @click="enableEditAddress('shipping')">
              <BaseIcon name="edit" />
              <span>編輯</span>
            </el-button>
          </li>
        </template> -->
      </ul>
      <div class="bottom-line-box-normal"></div>
      <h4 class="form-block-title">
        隸屬標籤
        <div v-if="editTagEnabled">
          <el-button class="is-round" size="mini" @click="cancelTagEdit">
            <BaseIcon name="times" />
            取消
          </el-button>
          <el-button class="is-round" size="mini" type="primary" :loading="tryingUpdateTag" @click="updateTag">
            <BaseIcon name="check" />
            <span>儲存</span>
          </el-button>
        </div>
        <el-button v-else type="primary" class="is-round" size="mini" plain @click="enableEditTag">
          <BaseIcon name="edit" />
          <span>編輯</span>
        </el-button>
      </h4>
      <div v-if="editTagEnabled">
        <div style="color: #aaaaaa; margin-bottom: 10px;">標籤</div>
        <el-select v-model="submitData.tags" value-key="id" multiple placeholder="請選擇" class="is-border">
          <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag"> </el-option>
        </el-select>
      </div>
      <div v-else :class="$style['label-tag']">
        <span>標籤：</span>
        <el-tag v-for="tag in defaultData.tags" :key="`tag-${tag.id}`" class="isStyleTag" disable-transitions>
          {{ tag.title }}
        </el-tag>
      </div>
    </div>
    <el-dialog :title="`編輯${addressMode === 'billing' ? '帳單' : ''}地址`" :visible.sync="visibleDialog" top="0" width="680px" append-to-body @close="handleClose">
      <template v-if="submitData[`${addressMode}Info`]">
        <el-form ref="addressForm" :model="submitData" :rules="addressRules" label-position="top" class="el-form--floating" style="margin-top: 30px">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].name" class="bg-white is-border"> </el-input>
                <el-input v-else v-model="submitData[`${addressMode}Info`].name" class="bg-white is-border"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="addressMode === 'shipping'" label="電話" prop="shippingInfo.0.phone">
                <el-input v-model="submitData[`${addressMode}Info`][0].phone" class="bg-white is-border"> </el-input>
              </el-form-item>
              <el-form-item v-else label="電話" prop="billingInfo.phone">
                <el-input v-model="submitData[`${addressMode}Info`].phone" class="bg-white is-border"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="addressMode === 'billing'" label="電子郵件">
            <el-input v-model="submitData[`${addressMode}Info`].email" class="bg-white is-border"> </el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="縣市">
                <el-select v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].city" placeholder="請選擇縣市" filterable class="is-border" @change="onSelectCity">
                  <el-option v-for="(city, index) in taiwanCitys" :key="`billing-city-${index}`" :label="city.name" :value="city.name"> </el-option>
                </el-select>
                <el-select v-else v-model="submitData[`${addressMode}Info`].city" placeholder="請選擇縣市" filterable class="is-border" @change="onSelectCity">
                  <el-option v-for="(city, index) in taiwanCitys" :key="`billing-city-${index}`" :label="city.name" :value="city.name"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="鄉鎮市區">
                <el-select
                  v-if="addressMode === 'shipping'"
                  v-model="submitData[`${addressMode}Info`][0].district"
                  placeholder="請選擇鄉鎮市區"
                  filterable
                  class="is-border"
                  @change="onSelectDistrict"
                >
                  <el-option v-for="(district, index) in districts" :key="`billing-district-${index}`" :label="district.name" :value="district.name"> </el-option>
                </el-select>
                <el-select v-else v-model="submitData[`${addressMode}Info`].district" placeholder="請選擇鄉鎮市區" filterable class="is-border" @change="onSelectDistrict">
                  <el-option v-for="(district, index) in districts" :key="`billing-district-${index}`" :label="district.name" :value="district.name"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="郵政編號">
            <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].postcode" class="bg-white is-border"> </el-input>
            <el-input v-else v-model="submitData[`${addressMode}Info`].postcode" class="bg-white is-border"> </el-input>
          </el-form-item>
          <el-form-item label="詳細地址">
            <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].address" class="bg-white is-border"> </el-input>
            <el-input v-else v-model="submitData[`${addressMode}Info`].address" class="bg-white is-border"> </el-input>
          </el-form-item>
        </el-form>
        <div :class="$style.footer">
          <el-button class="is-round" @click="visibleDialog = false">取消</el-button>
          <el-button class="is-round" :loading="tryingSave" :disabled="tryingSave" type="primary" @click="onSaveAddress">儲存</el-button>
        </div>
      </template>
    </el-dialog>
    <BaseButtonDialog width="550px" :only-dialog="true" :title="'客戶手機變更申請'" :dialog-visible.sync="dialogMemberPhoneApplyVisible" :destroy="true" floating @closed="handleMemberPhoneApplyClose">
      <div>
        <div style="color: #404040; line-height: 1.85; letter-spacing: 0.15em">
          因手機號碼為系統辨識客戶之唯一識別值，所有客戶個資均與綁定於原手機號碼，若任意變更手機號碼會有個資外洩的可能性，為避免誤觸僅能透過店家送出申請由客服人員變更。
        </div>
        <div class="d-flex justify-content-md-between flex-wrap">
          <p><span class="">客戶姓名：</span>{{ submitData.fullName }} {{ submitData.gender | genderFilter }}</p>
          <p class="Jost"><span class="">原號碼：</span>{{ `${submitData.phoneCode}-${submitData.phoneNumber}` }}</p>
        </div>
        <el-divider class="my-2"></el-divider>
        <el-form :model="submitPhone" :rules="rules">
          <el-form-item label="新號碼" prop="phoneNumber" class="el-form-item--normal-margin">
            <el-input v-model="submitPhone.phoneNumber" placeholder="請輸入新電話號碼" class="bg-white is-border" @input="onInputPhoneNumber">
              <CountryCodePicker slot="prepend" v-model="submitPhone.phoneCode" />
            </el-input>
            <!-- <small v-if="!isHasPhoneNumber && isCheckRegExp" class="el-form-item__success" style="">此號碼可使用</small> -->
            <!-- <small v-if="isHasPhoneNumber && isCheckRegExp" class="el-form-item__error">此號碼已被註冊</small> -->
          </el-form-item>
        </el-form>
        <div v-if="isHasPhoneNumber" class="d-flex justify-content-md-between flex-wrap mt-4">
          <p><span class="">客戶姓名：</span>{{ phoneMmeber.name }} {{ phoneMmeber.gender | genderFilter }}</p>
          <p class="Jost"><span class="">號碼：</span>{{ `${phoneMmeber.phoneCode}-${phoneMmeber.phoneNumber}` }}</p>
        </div>
        <el-button :disabled="!isCheckRegExp" type="primary" class="is-round w-100 mt-3" @click="tryToSendPhoneApply">
          確認申請更換
        </el-button>
      </div>
      <!-- <BaseButtonDialog
          width="550px"
          :only-dialog="true" 
          :title="'號碼確認'" 
          :dialog-visible.sync="innerDialogNextCheckApplytVisible" 
          :destroy="true"
          floating
        >
          <p class="mb-4 text-center" style="color: #404040; line-height: 1.85; letter-spacing: 0.15em">
            請問您是否已確認此新舊號碼均為該客戶所有？
          </p>
          <div>
            <p><span class="">客戶姓名：</span>{{ submitData.fullName }} {{ submitData.gender | genderFilter }}</p>
            <p class="Jost"><span class="">原號碼：</span>{{ `${submitData.phoneCode} ${submitData.phoneNumber}` }}</p>
            <p class="Jost"><span class="">新號碼：</span>{{ `${submitPhone.phoneCode} ${submitPhone.phoneNumber}` }}</p>
          </div>
          <el-button 
            type="primary" 
            class="is-round w-100 mt-3"
            @click="submitMemberPhoneApply"
          >
            已確認，送出申請
          </el-button>
          <el-button 
            class="is-round w-100 mt-3 ml-0"
            @click="innerDialogNextCheckApplytVisible = false"
          >
            否，回上一步
          </el-button>
        </BaseButtonDialog> -->
    </BaseButtonDialog>
  </div>
</template>
<style lang="scss" module>
.detail li {
  line-height: 40px;
}

.label-tag {
  :global {
  }
}

.footer {
  display: flex;

  :global {
    button {
      flex: 1 0 auto;
    }
  }
}

.detail-form {
  // width:550px;

  // @include max-sm {
  //   width: 100%;
  // }
  :global {
    .el-input-group__append,
    .el-input-group__prepend {
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
